<template>
  <div class="popup"  :class="description? 'showHide':'' ">
    <div class="popup-inner" ref="popup">
      <button class="close"
        @click="closePopup()"></button>
      
      <div class="content finTools" v-if="mode ==='finTools'">
        <main>
          <img :src="content.icon" alt="">
          <h3>{{ content.description.name }}</h3>
          <div class="description" v-if="content.description.text">
            <p v-for="(p, i) in content.description.text" :key="i">{{ p }}</p>
          </div>
          <div class="textBlock">
          <h5>{{ $parent.content[4].finTools.subHeading0 }}</h5>
          <p v-if="content.description.profit">
            от <span>{{ content.description.profit.split('-')[0] }}</span> 
            до <span>{{ content.description.profit.split('-')[1] }}</span>%
          </p>
          <p v-else><span>0</span>%</p>
          </div>
          <div class="risks">
          <h5>{{ $parent.content[4].finTools.subHeading1 }}</h5>
          <p v-for="(p,i) in getRisks()" 
            :key="i"
            v-html="p">
          </p>
          </div>
        </main>
        <div class="calcDescription modeLink">
          <a class="toggleDescription" target="_blank" :href="content.link">
            {{ content.calc_description }}
          </a>
        </div>
      </div>

      <div class="content index" v-if="mode ==='index'">
        <main>
          <img :src="$parent.popupData.icon" alt="">
          <h3>{{ content.description.name }}</h3>
          <div class="description" v-if="content.description.text">
            <p v-for="(p, i) in content.description.text" :key="i">{{ p }}</p>
          </div>
          <div class="textBlock">
          <h5>{{ $parent.content[4].index.subHeading0 }}</h5>
          <p>
            <span>{{ $parent.popupData.name }}</span>
          </p>
          </div>
          <div class="textBlock">
          <h5>{{ $parent.content[4].index.subHeading1 }}</h5>
          <p>
            <span>{{ Math.round(content.startPrice).toLocaleString('ru') }}</span> ₽
          </p>
          </div>
          <div class="textBlock last">
          <h5>{{ $parent.content[4].index.subHeading2 }}</h5>
          <p v-if="content.description.priceChange">
            <span>{{ content.description.priceChange }}</span>%
          </p>
          </div>
        </main>
        <div class="calcDescription modeLink">
          <a class="toggleDescription" target="_blank" :href="content.link">
            {{ content.calc_description }}
          </a>
        </div>
      </div>

      <div class="content unit" v-if="mode ==='unit'">
        <main class="unitMain">
          <img :src="$parent.popupData.icon" alt="">
          <h3>{{ $parent.popupData.name }}</h3>
          <div class="description">
            <p>{{ $parent.popupData.description }}</p>
          </div>
          <div class="textBlock bigPadding" :class="!description? 'last':''">
          <h5>{{ $parent.content[4].unit.subHeading0 }} <span>2 года</span></h5>
          <p class="unitValue"><span>
            {{ Math.round(getPriceToDate(24, $parent.popupData)).toLocaleString('ru') }}</span>₽
          </p>
          <h5 class="unitInfo">или <span>{{ (getPriceToDate(24, $parent.popupData)/content.startPrice).toFixed(2) }}</span> 
            {{ content.dataset.find(el => el.unit).name }}
          </h5>
          </div>
        </main>

        <main class="hideMain" v-if="description">
          <h3 class="calcInfoHeading">{{ content.description.name }}</h3>
          <div class="description" v-if="content.description.text">
            <p v-for="(p, i) in content.description.text" :key="i">{{ p }}</p>
          </div>
          <div class="textBlock">
          <h5>{{ $parent.content[4].index.subHeading0 }}</h5>
          <p>
            <span>{{ popupData.name }}</span>
          </p>
          </div>
          <div class="textBlock">
          <h5>{{ $parent.content[4].index.subHeading1 }}</h5>
          <p>
            <span>{{ Math.round(content.startPrice).toLocaleString('ru') }}</span> ₽
          </p>
          </div>
          <div class="textBlock last">
          <h5>{{ $parent.content[4].index.subHeading2 }}</h5>
          <p v-if="content.description.priceChange">
            <span>{{ content.description.priceChange }}</span>%
          </p>
          </div>
        </main>

        <div class="calcDescription unit">
          <a class="toggleDescription" target="_blank" :href="content.link"
            @click="openPopup($event)">
            {{ description? content.calc_description: 
              $parent.content[4].unit.btnContent + ' ' + content.nameRu }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Popup',
  props: ['content', 'mode'],
  data(){return {
    description: false,
    popupContent: null,
    popupMode: null,
    popupData: null
  }},
  mounted() {
    document.addEventListener('click', e => {
      if (this.$parent.popupOpened === true &&
        !e.target.closest('.info') && !e.target.closest('.info-heading')) {
        if (!e.target.closest('.popup')) this.$parent.popupOpened = false
      }
    })
    this.$refs.popup.addEventListener('click', e=>{
      if (+e.target.dataset.i>=0) {
        e.preventDefault()
        this.changePopup(this.$parent.finTools[+e.target.dataset.i],'finTools')
      }
    })
  },
  methods: {
    openPopup(e) {
      if (this.description) return
      e.preventDefault()
      if (this.content.name === 'devices') this.loadFullPopup(this.$parent.dimensions[0],'index', this.$parent.dimensions[0].dataset)
      if (this.content.name === 'cars') this.loadFullPopup(this.$parent.dimensions[1],'index', this.$parent.dimensions[1].dataset)
      if (this.content.name === 'real_estate') this.loadFullPopup(this.$parent.dimensions[2],'index', this.$parent.dimensions[2].dataset)
    },
    getPriceToDate(months, dimension){
      let price = dimension.startPrice;
      for(months; months >0; months--){
        price += price * dimension.coefficient;
      }
      return price;
    },
    toggleDescription(scroll){
      this.description = !this.description
      if (scroll) setTimeout(() => {
        document.querySelector('.toggleDescription').scrollIntoView({block:"start", behavior: "smooth"})
      }, 500);
    },
    changePopup(content, mode, data) {
      this.description = false
      this.$parent.popupOpened = false
      setTimeout(()=>this.$parent.popupOpened = true, 500)
      this.$parent.popupContent = content
      this.$parent.popupMode = mode
      if (data && mode === 'index') data = data.find(el => el.unit)
      this.$parent.popupData = data
      setTimeout(() => {
        document.querySelector('.popup img').scrollIntoView({block: "start", behavior: "smooth"})
      }, 500)
    },
    loadFullPopup(content, mode, data) {
      this.description = true
      this.popupContent = content
      this.popupMode = mode
      if (data && mode === 'index') data = data.find(el => el.unit)
      this.popupData = data
      setTimeout(() => {
        document.querySelector('.calcInfoHeading').scrollIntoView({block: "start", behavior: "smooth"})
      }, 500)
    },
    getRisks() {
      let txt = this.content.description.risks.text
      let arr = []
      let i = null
      let name = this.content.description.risks.linkToName

      this.$parent.finTools.filter((a, index)=> a.name === name? i = index :'')
      
      txt.forEach(str => {
        arr.push( str.split('<link>').join(`
            <a class="link" data-i="${i}">${ this.content.description.risks.linkText }</a>
        `))
      })
      return arr
    },
    closePopup() {
      this.description = false
      this.$parent.popupOpened = false
    }
  },
}
</script>

<style scoped lang="scss">
@import '@/assets/main.scss';

.popup {
  transition: 0.3s cubic-bezier(0.215, 0.610, 0.355, 1);
  max-width: 425px;
  z-index: 999;
  width: 100%;
  height: calc(100% - 25px);
  position: fixed;
  bottom: 0;
  opacity: 0;
  left: 50%;
  transform: translate(-50%, 100%);
  background: rgba($white, 0.9);
  border-radius: 30px 30px 0 0;
  padding-top: 20px;
  &.active {
    opacity: 1;
    transform: translate(-50%, 0%);
    .popup-inner .close {
      transform: scale(1) translateY(0);
    }
  }
  .popup-inner {
    z-index: 23;
    position: relative;
    width: 100%;
    height: 100%;
    .close {
      cursor: pointer;
      width: 40px;
      height: 40px;
      border: none;
      border-radius: 50%;
      position: absolute;
      top: -40px;
      transition: 0.3s ease 0.5s;
      transform: scale(0) translateY(-50%);
      z-index: 999;
      right: 20px;
      backdrop-filter: blur(10px);
      background: rgba($white, 0.9)  no-repeat url('../assets/img/close.svg') center/50%;
      box-shadow: 4px 4px 20px rgba(36, 36, 36, 0.2);
    }
    .content {
      overflow-y: auto;
      height: 100%;
      padding: 0;
      main {
        margin-bottom: 50px;
        padding: 0 20px 0px;
      }
      img {
        display: block;
        margin: 0 auto;
        width: 100%;
        height: 360px;
      }
      &.unit {
        padding-bottom: 15px;
      }
    }
  }
}

h3 {
  margin: 15px 0 0;
  font-family: 'Rubik', sans-serif;
  font-weight: 500;
  font-size: 22px;
  line-height: 26px;
}
p {
  font-family: 'Rubik', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  &:not(:last-child) {
    margin-bottom: 10px;
  }
  }
.description {
  margin: 5px 0 0;
  padding-bottom: 15px;
  border-bottom: 2px solid rgba(0, 0, 0, 0.15);
  font-family: 'Raleway', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
}
h5 {
  margin: 0 0 5px;
  font-family: 'Raleway', sans-serif;
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  span {
    color: $pop_sum;
  }
  &.unitInfo {
    margin-top: 5px;
  }
}
.textBlock {
  transition: 0.3s ease;
  margin: 15px 0 0;
  padding-bottom: 15px;
  border-bottom: 2px solid rgba(0, 0, 0, 0.15);
  &.last {
    border: none;
    padding: 0;
  }
  &.bigPadding {
    padding-bottom: 30px;
  }
  p {
    padding: 0;
    margin: 0;
    font-family: 'Rubik', sans-serif;
    font-weight: 800;
    font-size: 20px;
    line-height: 23px;
    .unitValue {
      margin: 5px 0;
    }
    span {
      font-size: 40px;
      font-weight: 500;
      line-height: 47px;
    }
  }
}

.index .textBlock p {
  margin-top: 5px;
}

.risks {
  margin: 15px 0 30px;
  h5 {
    margin-bottom: 5px;
  }
}

.unitMain {
  margin-bottom: 0 !important;
}
.showHide {
  .calcDescription.unit {
    transition: 0.3s linear 0.5s;
    background: #292951;
  }
  .hideMain {
    margin-top: 30px !important;
  }
}

.calcDescription {
  transition: 0.5s ease;
  position: fixed;
  top: calc(100% - 30px);
  width: 100%;
  overflow-y: auto;
  height: 30px;
  background: #292951;
  &.unit {
    background: $pop_sum;
  }
  .toggleDescription {
    cursor: pointer;
    transition: 0.5s ease;
    height: 30px; 
    color: $white;
    border: none;
    display: block;
    width: 100%;
    font-family: 'Rubik', sans-serif;
    font-weight: 500;
    font-size: 14px;
    line-height: 30px;
    text-align: center;
    position: sticky;
    top: 0;
  }
  .descriptionContent {
    margin: 0;
    font-family: 'Raleway', sans-serif;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    padding: 0;
    transition: 0.5s ease;
    padding: 15px;
    overflow: visible;
    p {
      margin: 0;
    }
  }
}

</style>